import styled from 'styled-components';
import { PriorityNumber, PriorityNumberProps } from '../../components/PriorityNumber';
import { BranchNameField, BranchNameFieldProps } from './BranchNameField';
import { BranchDragCard } from './BranchDragCard';
import { BranchDropzone } from './BranchDropzone';

export interface BranchPrioritySectionProps extends PriorityNumberProps, BranchNameFieldProps {}

const Container = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.designToken.spacing3};
`;

export const BranchPrioritySection = ({ priority, id, name }: BranchPrioritySectionProps) => {
  return (
    <Container>
      <PriorityNumber priority={priority} />
      <BranchDropzone id={id}>
        <BranchDragCard id={id}>
          <BranchNameField id={id} name={name} />
        </BranchDragCard>
      </BranchDropzone>
    </Container>
  );
};
